<template>
  <div class="show-actions-container text-right">
    <slot></slot>
<!--    <button class="show-action-btn download ml-2" @click="$emit('clickOnDownloadBtn')" v-if="downloadItem">-->
<!--       <download-icon  size="18"/>-->
<!--    </button>-->
    <button class="show-action-btn resetPassword ml-1" @click="$emit('clickOnResetPasswordBtn')" v-if="resetPassword">
      <img class="btn-icon" :src="require(`@/assets/images/reset-password.svg`)" alt="reset password icon" height="18">
    </button>
    <button class=" show-action-btn sendNotification ml-1" @click="$emit('clickOnSendNotificationBtn')" v-if="sendNotification">
      <i class="ph-custom ph-chat-text"/>
    </button>
    <button class="ph-btn show-action-btn edit ml-1" @click="$emit('clickOnEditBtn')" v-if="editItem">
      <i class="ph-custom ph-pencil-simple-line-fill "/>
    </button>
    <button class="ph-btn show-action-btn delete ml-1" @click="$emit('clickOnDeleteBtn')" v-if="deleteItem">
      <i class="ph-custom ph-trash-fill "/>
    </button>
    <button class="ph-btn show-action-btn validate ml-1" @click="$emit('clickOnValidateBtn')" v-if="validateItem">
      <i class="ph-custom ph-check-circle"/>
    </button>
    <button class="ph-btn show-action-btn refuse ml-1" @click="$emit('clickOnRefuseBtn')" v-if="refuseItem">
      <i class="ph-custom ph-x-circle"/>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ShowActions',

  props: {
    resetPassword: {
      type: Boolean,
      default: false
    },
    sendNotification: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Boolean,
      default: true
    },
    deleteItem: {
      type: Boolean,
      default: true
    },
    downloadItem: {
      type: Boolean,
      default: false
    },
    validateItem: {
      type: Boolean,
      default: false
    },
    refuseItem: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

.show-actions-container {
  min-width: 300px;
  display: flex;
  justify-content: flex-end;
}
.show-action-btn {
  border: none;
  display: inline-flex;
  padding: 6px 8px;
  border-radius: 4px;
  font-family: "Museo700", "Arial", sans-serif;
  font-size: 14px;
  color: var(--main-black-medium);
}
.show-action-btn:hover {
  background-color: var(--main-yellow-dark);
}

.edit {
  background-color: var(--main-yellow-medium);

}
.edit:hover {
  background-color: var(--main-yellow-dark);
}

.delete{
  background-color: var(--main-red-medium);
}
.delete:hover {
  background-color: var(--main-red-dark);
}

.delete.delete-asked{
  background-color: var(--main-red-lighter);
}
.delete.delete-asked:hover {
  background-color: var(--main-red-light);
}

.resetPassword {
  background-color: var(--main-grey-medium);
}
.resetPassword:hover {
  background-color: var(--main-grey-dark);
}

.download {
  background-color: var(--main-yellow-medium);
}

.download:hover {
  background-color: var(--main-yellow-dark);
}

.sendNotification{
  background-color: transparent;
  border: var(--main-yellow-medium) solid 1px;
  color: var(--main-yellow-medium);
}
.sendNotification:hover {
  background-color: var(--main-yellow-medium) !important;
  border-color: var(--main-yellow-medium) !important;
  color: var(--main-white) !important;
}

.refuse{
  background-color: var(--main-red-medium);
}
.refuse:hover {
  background-color: var(--main-red-dark);
}

.validate{
  background-color: var(--main-green-medium);
}
.validate:hover {
  background-color: var(--main-green-dark);
}

</style>



// WEBPACK FOOTER //
// src/components/b122/ShowActions.vue